<template>
  <ul class="faqs__list">
    <li
      v-for="item in accordion"
      :key="item.title"
      class="faqs__list-item"
    >
      <h3
        class="faqs__list-item-title"
        @click="item.show = !item.show"
      >
        {{ item.title }}
        <MinusCircle v-if="item.show" />
        <PlusCircle v-else />
      </h3>
      <Vue3SlideUpDown
        v-model="item.show"
        :duration="accordionDuration"
        class="faqs__list-item-text rte"
        v-html="item.answer"
      />
    </li>
  </ul>
</template>

<script>
import { Vue3SlideUpDown } from "vue3-slide-up-down"

import PlusCircle from '../../icons/plus-circle'
import MinusCircle from '../../icons/minus-circle'


export default {
  name: 'ProductFaqsAccordion',
  components: {
    PlusCircle,
    MinusCircle,
    Vue3SlideUpDown,
  },
  props: {
    accordionData: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      accordion: [...this.accordionData],
      accordionDuration: 300
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>